import { IHeader } from "../../common/components/AgGrid/index";
import { SCAttributes } from "../../common/generic/generic-sc-attributes";
import { IGenericAggregateResponse } from "../../common/generic/generic-types";
import { SCProfileDictionary } from "../../common/salescredit/salescredit-profile-dictionary";
import {
  ICprSalescreditRevenueKpi,
  ICprSalesCreditSearchCriteria,
  INbiSalescreditResponse,
} from "../../common/utils/types";
import { ISalesByCountryData } from "./types";

export function getMapping(
  data: IGenericAggregateResponse,
  profile: string
): ISalesByCountryData | undefined {
  if (!data.aggregates || data.aggregates.length === 0) {
    return undefined;
  }
  const pd = new SCProfileDictionary();
  const profileKpis = pd.GetGridFields(profile);
  const rows: any[] = [];

  for (const item of data.aggregates) {
    const country =
      item.dimensionAttributeValues[SCAttributes.SC_MANDATE_COUNTRY];
    const row: { [field: string]: string | number } = {};
    row[SCAttributes.SC_MANDATE_COUNTRY] = country;
    for (const kpiRaw of profileKpis) {
      row[kpiRaw.Kpi] = item.indicatorKpiValues[kpiRaw.Kpi];
    }
    rows.push(row);
  }
  return { Headers: buildHeaders(profile), Rows: rows };
}

export function buildHeaders(profile: string) {
  const headers: IHeader[] = [
    {
      field: SCAttributes.SC_MANDATE_COUNTRY,
      headerName: "Country",
      suppressSizeToFit: true,
      width: 220,
    },
  ];
  const pd = new SCProfileDictionary();
  const headerKpis = pd.GetGridFields(profile);

  for (const kpiRaw of headerKpis) {
    headers.push(kpiRaw.HeaderFormat);
  }
  return headers;
}
